/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ClearInputs */

const en_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const es_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar`)
};

const fr_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer`)
};

const de_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeren`)
};

const ja_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア`)
};

const zh_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除`)
};

const ar_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح`)
};

const id_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bersihkan`)
};

const it_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulisci`)
};

const ru_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить`)
};

const pt_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar`)
};

const ko_clear = /** @type {(inputs: ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지우기`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {ClearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const clear = /** @type {((inputs?: ClearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ClearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear(inputs)
	if (locale === "es") return es_clear(inputs)
	if (locale === "fr") return fr_clear(inputs)
	if (locale === "de") return de_clear(inputs)
	if (locale === "ja") return ja_clear(inputs)
	if (locale === "zh") return zh_clear(inputs)
	if (locale === "ar") return ar_clear(inputs)
	if (locale === "id") return id_clear(inputs)
	if (locale === "it") return it_clear(inputs)
	if (locale === "ru") return ru_clear(inputs)
	if (locale === "pt") return pt_clear(inputs)
	return ko_clear(inputs)
});